import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Layout.module.scss';
import clsx from 'clsx';
import { userMe } from '../../redux/actions/user/userMe';
import Loading from '../Loading/Loading';
import { useLocation, useNavigate } from 'react-router';
import { resetUserMe } from '../../redux/slices/user.slice';
import SideBar from '../SideBar/SideBar';
import Button from '../Button/Button';
import Link from '../Link/Link';
import { ToastContainer } from 'react-toastify';
import { Tooltip } from 'react-tooltip';
import { useMediaQuery } from '../../utils/useMediaQuery';
import Footer from '../Footer/Footer';

const userMenu = [
  {
    label: 'Дашборд',
    link: '/cabinet/user/dashboard',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    ),
  },
  {
    label: 'Профиль',
    link: '/cabinet/user/profile',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
  },
  {
    label: 'Пропуска',
    link: '/cabinet/user/pass',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <path d="M16 10a4 4 0 0 1-8 0"></path>
      </svg>
    ),
  },
  null,
  {
    label: 'Подписка',
    link: '/cabinet/subscription',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sidebar">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="9" y1="3" x2="9" y2="21"></line>
      </svg>
    ),
  },
];
const partnerMenu = [
  {
    label: 'Дашборд',
    link: '/cabinet/partner/dashboard',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    ),
  },
  {
    label: 'Профиль',
    link: '/cabinet/partner/profile',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
  },
  {
    label: 'Игры',
    link: '/cabinet/partner/games',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <path d="M16 10a4 4 0 0 1-8 0"></path>
      </svg>
    ),
  },
  null,
  {
    label: 'API',
    link: '/cabinet/partner/api',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sidebar">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="9" y1="3" x2="9" y2="21"></line>
      </svg>
    ),
  },
];
const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    userMe: { data: userMeData, loading: userMeLoading, error: userMeError },
  } = useSelector((state) => state.user);
  useEffect(() => {
    dispatch(userMe());
  }, []);
  useEffect(() => {
    if (userMeError) {
      // navigate('/');
      dispatch(resetUserMe());
    }
  }, [userMeError]);
  const [show, setShow] = useState(false);
  const isMobile = useMediaQuery('(max-width:1024px)');
  const isTablet = useMediaQuery('(max-width:1140px)');

  return userMeData ? (
    <>
      <div className={clsx(styles.wrap)}>
        <header className={clsx(styles.header, !show && styles.headerFull)}>
          {' '}
          <div className={clsx(styles.head, styles.headInHeader, !show && styles.headInHeaderShow)}>
            <img
              src="/img/logo.png"
              alt=""
              className={clsx(styles.logo)}
              onClick={() => {
                navigate('/');
              }}
            />
            <div
              className={clsx(styles.burger)}
              onClick={() => {
                setShow(true);
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid status_toggle middle sidebar-toggle">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </div>
          </div>
          <div className={clsx(styles.support)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            {!isMobile && <Link> Поддержка</Link>}
          </div>
          <Button
            onClick={() => {
              localStorage.removeItem('accessToken');
              dispatch(userMe());
            }}
            type="danger"
            rightIcon={
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            }>
            Выход
          </Button>
        </header>
        <SideBar
          onClose={() => {
            if (isTablet) {
              setShow(false);
            }
            // setShow(false);
          }}
          show={show}
          className={clsx(styles.sidebar)}
          width={265}
          direction="left">
          <div className={clsx(styles.head)}>
            <img
              src="/img/logo.png"
              alt=""
              className={clsx(styles.logo)}
              onClick={() => {
                navigate('/');
              }}
            />
            <div
              className={clsx(styles.burger)}
              onClick={() => {
                setShow(false);
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid status_toggle middle sidebar-toggle">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </div>
          </div>
          <div className={clsx(styles.divider)} style={{ marginTop: '20px' }}></div>
          <div className={clsx(styles.list)}>
            {(userMeData?.type == 'USER' ? userMenu : userMeData?.type == 'PARTNER' ? partnerMenu : [])?.map((item) =>
              !item ? (
                <div className={clsx(styles.divider)}></div>
              ) : (
                <div
                  className={clsx(styles.item, pathname == item?.link && styles.itemActive)}
                  onClick={() => {
                    navigate(item?.link);
                    if (isTablet) {
                      console.log('qwer');

                      setShow(false);
                    }
                  }}>
                  <div className={clsx(styles.icon)}>{item?.icon}</div>
                  <div className={clsx(styles.label)}>{item?.label}</div>
                </div>
              ),
            )}
          </div>
        </SideBar>{' '}
        <div className={clsx(styles.content, !show && styles.contentFull)}>
          <ToastContainer theme="colored" /> {children}
          <Tooltip id="tooltip" />
        </div>
        <Footer show={show} />
      </div>
    </>
  ) : userMeLoading || userMeError ? (
    <div className={clsx(styles.wrap)} style={{ justifyContent: 'center' }}>
      {' '}
      <Loading />
    </div>
  ) : (
    <></>
  );
};

export default Layout;
